module.exports = __webpack_public_path__ + "img/img01.97504274.jpg";